export class Waiting {

    public id: string = "0";
    public createdAt: Date;
    public product_id: string;
    public product_name: string;
    public member_id: string;
    public member_name: string;
    public member_email: string;
    public category_id: string;
    public category_name: string;

    public waiting: boolean;
    public allowed: boolean;
    
    constructor() {}
}